import React, { Component } from 'react';
import { connect } from 'react-redux';
import { NavBar, DataTables, BreadCumb, TimeOut, ActiveRoutes, PolygonMap } from '../../components';
import { DISPATCH_ID, SERVICE_RESPONSE } from '../../libs/utils/Const';
import { ApiClient } from '../../libs/apiClient';
import config from '../../config';
import moment from "moment";
import { io } from 'socket.io-client';
let apiClient = ApiClient.getInstance();
const TODAY = moment(new Date()).format('YYYY-MM-DD');

const headersDataTable = [
    { title: "Folio", value: true }, // 0
    { title: "Estado", value: true },// 1
    { title: "Hoja de Ruta", value: true },// 2
    { title: "Fecha", value: true },// 2
    { title: "Transporte", value: true },// 3
    { title: "Figura Transporte", value: true },// 4
    { title: "Total", value: true },// 5
    { title: "Tipo de Atención", value: true },// 6
    { title: "Estatus", value: true },// 7
    { title: "Sucursal", value: true }, // 8
];

class AdminDeliveries20 extends Component {
    constructor(props) {
        super(props);

        this.state = {
            data: [],
            _user: JSON.parse(localStorage.getItem(config.localStorageNamed + 'currentUser')),
            vehicles: [],
            drivers: [],
            cTab: 0,
            started: false,
            localizations: [],
            activeRoutes: [],
            polygons: [],
            transports: [],
            currDocuments: [],
            deliveryPoints: [],
        }
        this.docsInterval = null;
        this.geoInterval = null;
        this.socket = null;
        this._isMounted = false;


    }

    async componentDidMount() {
        this._isMounted = true;
        this.startSocket();
        await this.getPolygons();
        await this.getInitialData();
        await this.getDeliveryDocs()
        localStorage.setItem(config.localStorageNamed + 'toogleNavBarItem', "liCartaPorte");
        const filter = {
            dateInit: TODAY,
            dateFinal: TODAY,
        }
        await this.callDocumentsListService(filter);

        // this.searchActiveRoutes();
        // this.geoInterval = setInterval(() => {
        //     this.searchActiveRoutes();
        // }, 5000);


    }
    getDeliveryDocs = async () => {
        const search = {}
        const responseApi = await apiClient.getTodayDocsCoordniates(search);

        if (responseApi.status == SERVICE_RESPONSE.SUCCESS) {
            this.setState({
                deliveryPoints: responseApi?.data || []
            })
        }
    }

    startSocket() {
        this.socket = io('https://saphana50.llamagas.nubeprivada.biz', {
            transports: ['websocket'],
            query: { role: 'admin' },
        });

        this.socket.on('connect', () => {
        });
        this.socket.on('initialLocations', (data) => {
            if (this._isMounted) {
                this.setState({ localizations: data });
            }
        });

        this.socket.on('locationUpdate', (data) => {
            if (this._isMounted) {
                this.setState((prevState) => {
                    const updated = [...prevState.localizations];
                    const index = updated.findIndex(
                        (loc) => loc.deviceId === data.deviceId
                    );

                    if (index !== -1) {
                        updated[index] = { ...updated[index], ...data };
                    } else {
                        updated.push(data);
                    }
                    return { localizations: updated };
                });
            }

        });
        this.socket.on('disconnect', () => {
        });

    }

    componentWillUnmount() {
        this._isMounted = false;

        if (this.socket) {
            this.socket.off('locationUpdate');
            this.socket.disconnect();
        }
        if (this.geoInterval) {
            clearInterval(this.geoInterval);
        }
        if (this.docsInterval) {
            clearInterval(this.docsInterval);
        }

    }

    getPolygons = async () => {
        const search = {}
        const responseApi = await apiClient.getPolygons(search);
        if (responseApi.status == SERVICE_RESPONSE.SUCCESS) {
            this.setState({
                polygons: responseApi?.data || []
            })
        }
    }

    clearDocsInterval() {
        if (this.docsInterval) {
            clearInterval(this.docsInterval);
        }

    }
    getDocumentsDriver = async (code) => {
        const { notificationReducer: { showAlert }, enableSpinner } = this.props;

        let search = {
            code
        }

        enableSpinner(true)
        const responseApi = await apiClient.getDriverDocuments(search);
        enableSpinner(false)
        if (responseApi.status == SERVICE_RESPONSE.SUCCESS) {
            this.setState({
                currDocuments: responseApi?.data?.listDocs || []
            })
            // if (this.docsInterval == null) {

            //     this.docsInterval = setInterval(async () => {
            //         await this.getDocumentsDriver(code);
            //     }, 2500);
            // }
        }
    }

    getInitialData = async () => {
        const { enableSpinner } = this.props
        const search = {}
        enableSpinner(true)
        const responseApi = await apiClient.getInitialData(search);
        enableSpinner(false)
        if (responseApi.status == SERVICE_RESPONSE.SUCCESS) {
            this.setState({
                transports: responseApi?.data?.transports || []
            })
        }
    }


    searchActiveRoutes = async () => {
        const search = {
            searchFrom: 'BRANCH'
        }
        const responseApi = await apiClient.listAssignedRoutes(search);


        if (responseApi.status === SERVICE_RESPONSE.SUCCESS) {
            const newlocalizations = []
            const newactiveRoutes = []
            const addLocation = new Set();
            for (let index = 0; index < responseApi?.data?.AssignedDocs?.length; index++) {
                const point = responseApi?.data?.AssignedDocs[index];
                newactiveRoutes.push(point)
                if (index === 1) {
                    point.LNG = -99.1332
                    point.LAT = 19.432
                }

                // const key = `${point.LAT},${point.LNG}`;
                // if (!addLocation.has(key)) {
                //     if (point.LNG != null && point.LAT != null) {
                //         newlocalizations.push({
                //             Code: point.Code,
                //             lng: Number(parseFloat(point.LNG).toFixed(4)),
                //             lat: Number(parseFloat(point.LAT).toFixed(4)),
                //         });
                //         addLocation.add(key);
                //     }

                // }


            }

            this.setState({
                // localizations: newlocalizations,
                activeRoutes: newactiveRoutes,
                started: true,
            })
        }

    }

    searchDocDeliveries = async filter => {
        await this.callDocumentsListService(filter);
    };
    cancelHR =async()=>{
        
    }

    callDocumentsListService = async (filters) => {
        const { notificationReducer: { showAlert }, enableSpinner } = this.props;

        enableSpinner(true);
        const responseApi = await apiClient.getCreatedRouteDeliveries20(filters);
        enableSpinner(false);

        if (responseApi.status === SERVICE_RESPONSE.SUCCESS) {
            if (responseApi.data.length === 0) {
                showAlert({ type: 'info', timeOut: 5000, message: "No se encontraron resultados correspondientes a la búsqueda." });
            }

            this.setState({
                data: responseApi?.data ?? [],
                // total: responseApi?.data.length ?? 0 
            });
        }
    };

    UpdateStateField = async (key, value) => {
        await this.setState({ [key]: value });
    }



    render() {
        const { cTab } = this.state;
        const { enableSpinner } = this.props
        const itemsDashboard = JSON.parse(localStorage.getItem(config.localStorageNamed + 'itemsDashboard'));
        const tabs = [
            {
                title: "General",
                component:
                    <DataTables
                        headers={headersDataTable}
                        view={"adminDeliveries20"}
                        data={this.state.data}
                        search={this.searchDocDeliveries}
                        totalRows={this.state.data.length}
                    />,
            },
            {
                title: "Rutas",
                component:
                    <div className="w-100" style={{ height: '60vh', overflow: 'auto', overflowY: 'auto' }}>
                        <div className="h-100">
                            <ActiveRoutes
                                data={this.state.activeRoutes}
                                localizations={this.state.localizations}
                                polygons={this.state.polygons}
                                transports={this.state.transports}
                                documentDriver={(code) => this.getDocumentsDriver(code)}
                                clearDocsInterval={this.clearDocsInterval}
                                currDocuments={this.state.currDocuments}
                                deliveryPoints={this.state.deliveryPoints}
                                getInitialData={this.getInitialData}
                            />
                        </div>
                    </div>
                // this.state.started ? 

                //  : <div style={{ textAlign: 'center', padding: '10px' }}>
                //     <div className="spinner" />
                //     <small>Cargando...</small>
                // </div>,
            },

        ];


        return (
            <div className="content">
                <NavBar props={this.props} itemsDashboard={itemsDashboard} _user={this.state._user} />
                <TimeOut />
                <BreadCumb subitem1={'GESTOR DE ENTREGAS FÍSICAS'} url1={'#'} />
                <div style={{ marginLeft: "4rem", marginBottom: "12rem" }}>
                    <h2 className="md-display-1"><a href=" " id="" className="text-muted">&nbsp;GESTOR DE ENTREGAS FÍSICAS</a></h2>
                    <div className="row ml-3">
                        <div className="w-100" >
                            <nav>
                                <div className="nav nav-tabs flex-nowrap flex-md-wrap" id="nav-tab" role="tablist">
                                    {tabs.map((tab, index) =>
                                        <label
                                            className={`nav-item nav-link font-weight-bold text-secondary text-nowrap ${cTab === index ? 'active' : ''}`}
                                            style={{ cursor: "pointer" }}
                                            onClick={() => this.UpdateStateField('cTab', index)}
                                            key={`tab-${index}`} >
                                            {tab.title}
                                        </label>
                                    )}
                                </div>
                            </nav>

                            <div className="tab-content border border-top-0 rounded-bottom p-2 p-md-3">
                                {tabs.map((tab, index) =>
                                    <div
                                        className={`tab-pane px-1 px-md-3 ${cTab === index ? 'active' : ''}`}
                                        key={`tabpanel-${index}`} >
                                        {cTab === index ? tab.component : ''}
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>


                </div>
            </div>
        );
    }
}

const mapStateToProps = store => {
    return { notificationReducer: store.NotificationReducer };
};

const mapDispatchToProps = dispatch => {
    return {
        enableSpinner: value => dispatch({ type: DISPATCH_ID.CONFIG_SET_SPINNER, value })
    };
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(AdminDeliveries20);